import React, { useState } from 'react';
import { PDFDownloadLink, PDFViewer, BlobProvider } from '@react-pdf/renderer';
import InvoicePDF from './InvoicePDF';

const AdministratorPage = () => {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div style={{ padding: '20px' }}>
      <h2>Invoice Generator</h2>
      
      {/* Download Button */}
      <PDFDownloadLink 
        document={<InvoicePDF />} 
        fileName="invoice.pdf"
        style={{
          padding: '10px 20px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginRight: '10px',
          textDecoration: 'none',
          display: 'inline-block'
        }}
      >
        {({ blob, url, loading, error }) =>
          loading ? 'Generating PDF...' : 'Download Invoice'
        }
      </PDFDownloadLink>

      {/* Print Button */}
      <button
        onClick={() => setShowPreview(!showPreview)}
        style={{
          padding: '10px 20px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginRight: '10px',
        }}
      >
        {showPreview ? 'Hide Preview' : 'Preview Invoice'}
      </button>

      {/* Print directly using browser print */}
      <BlobProvider document={<InvoicePDF />}>
        {({ url, loading }) => (
          <button
            onClick={() => {
              if (url) {
                const printWindow = window.open(url, '_blank');
                printWindow.onload = () => {
                  printWindow.print();
                };
              }
            }}
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: '#FF5722',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Print Invoice
          </button>
        )}
      </BlobProvider>

      {/* Preview Section */}
      {showPreview && (
        <div style={{ marginTop: '30px', height: '600px' }}>
          <PDFViewer width="100%" height="100%">
            <InvoicePDF />
          </PDFViewer>
        </div>
      )}
    </div>
  );
};

export default AdministratorPage;